import { handleActions } from 'redux-actions';
import { addressSuccess } from './actions';
import { logoutSuccess } from 'ducks/auth/actions';

import initialState from './states';

export default handleActions(
  {
    [addressSuccess](state, { payload }) {
      const { tableName, entityID } = payload;
      return {
        ...state,
        [tableName]: {
          ...(state[tableName] || {}),
          [entityID]: payload,
        },
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
